<nav class="app-bar-container">
  <div class="app-bar-title">
    @if(backButtonProps) {
      <mnt-button-icon
        [variant]="backButtonProps.variant"
        [color]="backButtonProps.color"
        [size]="backButtonProps.size"
        [icon]="backButtonProps.icon"
        (click)="handleBack()"
      ></mnt-button-icon>
    }

    <h1 class="label-medium-large">
      {{ title }}
    </h1>
  </div>

  @if(actionButtonProps) {
    <div class="app-bar-actions ml-auto">
      <mnt-button
        #labelButton
        *ngIf="(actionButtonProps)?.label"
        [variant]="(actionButtonProps)?.variant"
        [color]="(actionButtonProps)?.color"
        [size]="(actionButtonProps)?.size"
        [iconLeft]="(actionButtonProps)?.iconLeft"
        [label]="(actionButtonProps)?.label"
        (click)="handleAction()"
      ></mnt-button>
    </div>
  }
</nav>